import {
  DecisionTypesCode,
  ReportRejectionReasonType,
  UserRole,
  checkBoxNames,
} from "components/Reports/reportAssets/assets";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useClassReadOnlyByRole } from "hooks/useClassReadOnlyByRole";
import { useRole } from "hooks/useRole";
import { FormStepsProps } from "../FormStepsProps";
import RoadProblemSection from "./RoadProblemSection";

const ReportDetailsCheckboxs = ({
  control,
  errors,
  setValue,
  canvasImages,
  setCanvasImages,
  currentCroppedButton,
  setCurrentCroppedButton,
  addCroppedImageArray,
  setAddCroppedImageArray,
  value: propValue,
  getValues,
  reportIsDuplicate,
}: FormStepsProps) => {
  const { t } = useTranslation();
  const [shouldRenderTextArea, setShouldRenderTextArea] = useState(() =>
    getValues("roadMarkUnclear")
  );

  const classReadOnly = useClassReadOnlyByRole();
  const role = useRole();

  const handleChecked = (checkBoxName, checked: boolean) => {
    if (checkBoxName === checkBoxNames.roadMarkUnclear) {
      if (checked) setShouldRenderTextArea(true);
      else {
        setShouldRenderTextArea(false);
        setValue("roadProblemDescription", "");
        setValue("roadProblemPicture", null);
      }
    } else if (checkBoxName === checkBoxNames.licenseNumberUnclear) {
      if (checked) {
        setValue(
          "rejectionReasonID",
          ReportRejectionReasonType.licenseNumberUnclear
        );
        setValue("decisionTypeID", DecisionTypesCode.DisqualificationReport);
      } else {
        setValue("rejectionReasonID", "");
        setValue("decisionTypeID", "");
      }
    }
  };

  const renderTextArea = (checkBoxName) => {
    if (checkBoxName === checkBoxNames.roadMarkUnclear)
      return (
        <RoadProblemSection
          setValue={setValue}
          control={control}
          errors={errors}
          canvasImages={canvasImages}
          setCanvasImages={setCanvasImages}
          addCroppedImageArray={addCroppedImageArray}
          setAddCroppedImageArray={setAddCroppedImageArray}
          currentCroppedButton={currentCroppedButton}
          setCurrentCroppedButton={setCurrentCroppedButton}
          value={propValue}
        />
      );
    return null;
  };

  return (
    <section className="extra-lower-padding">
      <Row>
        <Col md={8}>
          {Object.entries(checkBoxNames)
            .slice(0, 4)
            .map(([checkBoxName, checkBoxValue]) => (
              <Controller
                key={checkBoxName}
                name={checkBoxNames[checkBoxName]}
                control={control}
                render={({ field: { onChange, name, value } }) => {
                  const isDisableMissingDetails =
                    checkBoxName === checkBoxNames.missingDetails &&
                    role === UserRole.REGULAR;
                  return (
                    <>
                      <div
                        className={
                          isDisableMissingDetails
                            ? classReadOnly
                            : "checboxes-container"
                        }
                      >
                        <Form.Check
                          className="report-desails-check"
                          id={`checkbox-${checkBoxName}`}
                          type="checkbox"
                          label={t(checkBoxValue)}
                          checked={value}
                          onChange={(e) => {
                            onChange(e);
                            handleChecked(name, e.target.checked);
                          }}
                          disabled={isDisableMissingDetails}
                        />
                      </div>
                      {shouldRenderTextArea && renderTextArea(name)}
                    </>
                  );
                }}
              />
            ))}
        </Col>

        <Col md={4}>
          {Object.entries(checkBoxNames)
            .slice(4)
            .map(([checkBoxName, checkBoxValue]) => (
              <Controller
                key={checkBoxName}
                name={checkBoxNames[checkBoxName]}
                control={control}
                render={({ field: { onChange, name, value } }) => {
                  const isDisableMissingDetails =
                    checkBoxName === checkBoxNames.missingDetails &&
                    role === UserRole.REGULAR;
                  return (
                    <>
                      <div
                        className={
                          isDisableMissingDetails
                            ? classReadOnly
                            : "checboxes-container"
                        }
                      >
                        <Form.Check
                          className="report-desails-check"
                          id={`checkbox-${checkBoxName}`}
                          type="checkbox"
                          label={t(checkBoxValue)}
                          checked={value}
                          onChange={(e) => {
                            onChange(e);
                            handleChecked(name, e.target.checked);
                          }}
                          disabled={isDisableMissingDetails}
                        />
                      </div>
                      {shouldRenderTextArea && renderTextArea(name)}
                    </>
                  );
                }}
              />
            ))}
        </Col>
      </Row>
    </section>
  );
};
export default ReportDetailsCheckboxs;
